import { IonCol, IonRow } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import './IndianCasinoView.scss';
import { connect } from 'react-redux';
import { RootState } from '../../../models/RootState';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';
import ExchBetslip from '../../../components/ExchBetslip/ExchBetslip';
import ExchOpenBets from '../../../components/ExchOpenBets/ExchOpenBets';
import { UserBet } from '../../../models/UserBet';
import { BsData, PlaceBetRequest } from '../../../models/BsData';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CasinoGamesMenu from './CasinoGamesMenu';
import { isIOS, isMobile } from 'react-device-detect';
import {
  isConnected,
  connectToWS,
  disconnectToWS,
} from '../../../webSocket/webSocket';
import { useParams } from 'react-router';
import Lucky7Game from './Games/Lucky7/Lucky7Game';
import Teenpatti2020Game from './Games/Teenpatti2020/Teenpatti2020Game';
import { CasinoGameDTO } from '../../../models/IndianCasinoState';
import { updateCasinoGames, setCasinoGame } from '../../../store';
import { AxiosResponse } from 'axios';
import API from '../../../api';
import {
  INDIAN_CASINO_GAMES_MAP,
  INDIAN_CASINO_GAMES,
} from '../../../constants/IndianCasinoGames';
import { DcGameNew } from '../../../models/dc/DcGame';

type StroeProps = {
  casinoGames: CasinoGameDTO[];
  selectedCasinoGame: CasinoGameDTO;
  updateCasinoGames: (casinoGames: CasinoGameDTO[]) => void;
  bets: PlaceBetRequest[];
  openBets: UserBet[];
  setCasinoGame: (cGame: CasinoGameDTO) => void;
  langData:any;
};

type RouteParams = {
  gameCode: string;
};

const IndianCasinoView: React.FC<StroeProps> = (props) => {
  const {
    casinoGames,
    selectedCasinoGame,
    updateCasinoGames,
    bets,
    openBets,
    langData,
    setCasinoGame,
  } = props;
  const { gameCode } = useParams<RouteParams>();
  const [openBetslip, setOpenBetslip] = useState<boolean>(true);
  // const isMobile = window.innerWidth > 1120 ? false : true;

  // Websocket handler
  // useEffect(() => {
  //   if (isConnected()) {
  //     disconnectToWS();
  //   }
  //   connectToWS();
  //   return () => {
  //     if (isConnected()) {
  //       disconnectToWS();
  //     }
  //   };
  // }, []);

  const fetchCasinoGames = async () => {
    const response: AxiosResponse<DcGameNew[]> = await API.get(
      '/dc/filtered-games'
    );
    const games = response.data.filter(
      (g) => g.category === 'Indian Casino Game'
    );
    let indianCasinoGamesList: CasinoGameDTO[] = [];
    // for (let ig of games) {
    //   if (INDIAN_CASINO_GAMES_MAP[ig.gameCode.toLowerCase()]) {
    //     indianCasinoGamesList.push(
    //       INDIAN_CASINO_GAMES.find((g) => g.id === ig.gameCode.toLowerCase())
    //     );
    //   }
    // }
    updateCasinoGames(indianCasinoGamesList);
  };

  useEffect(() => {
    if (casinoGames.length === 0) {
      fetchCasinoGames();
    }
  }, [casinoGames]);

  useEffect(() => {
    if (gameCode !== selectedCasinoGame.id) {
      setCasinoGame({
        id: gameCode,
        name: INDIAN_CASINO_GAMES.find((g) => g.id === gameCode).name,
      });
    }
  }, [gameCode, selectedCasinoGame]);

  return (
    <div className="indian-casiono-ctn">
      <IonRow>
        {!isMobile ? (
          <IonCol className="menu-section">
            <div className="sticky-col">
              <CasinoGamesMenu />
            </div>
          </IonCol>
        ) : null}
        <IonCol className="game-section">
          {gameCode === 'lucky7' || gameCode === 'lucky7b' ? (
            <Lucky7Game />
          ) : gameCode === 'tp2020' ? (
            <Teenpatti2020Game />
          ) : null}
        </IonCol>
        {!isMobile ? (
          <IonCol className="bets-section">
            <div className="sticky-col">
              <Accordion
                className="stream-accordion"
                expanded={openBetslip}
                onChange={(_, expanded) => setOpenBetslip(expanded)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon className="expand-icon" />}
                  aria-controls="panel1a-content"
                  className="stream-header"
                >
                  {langData?.['bet_slip']} ({bets.length})
                </AccordionSummary>
                <AccordionDetails className="stream-body">
                  {bets.length > 0 ? <ExchBetslip /> : null}
                </AccordionDetails>
              </Accordion>
              <Accordion className="stream-accordion" defaultExpanded={true}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon className="expand-icon" />}
                  aria-controls="panel1a-content"
                  className="stream-header"
                >
                  Open Bets ({openBets.length})
                </AccordionSummary>
                <AccordionDetails className="stream-body">
                  {openBets.length > 0 ? <ExchOpenBets /> : null}
                </AccordionDetails>
              </Accordion>
            </div>
          </IonCol>
        ) : null}
      </IonRow>
      {isMobile ? (
        <div
          className={isIOS ? 'betslip-section ios-betslip' : 'betslip-section'}
        >
          <Accordion
            className="stream-accordion"
            expanded={openBetslip}
            onChange={(_, expanded) => setOpenBetslip(expanded)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className="expand-icon" />}
              aria-controls="panel1a-content"
              className="stream-header"
            >
              {langData?.['bet_slip']} ({bets.length})
            </AccordionSummary>
            <AccordionDetails className="stream-body">
              {bets.length > 0 ? <ExchBetslip /> : null}
            </AccordionDetails>
          </Accordion>
        </div>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    casinoGames: state.indianCasino.casinoGames,
    selectedCasinoGame: state.indianCasino.selectedGmae,
    bets: state.exchBetslip.bets,
    openBets: state.exchBetslip.openBets,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    updateCasinoGames: (casinoGames: CasinoGameDTO[]) =>
      dispatch(updateCasinoGames(casinoGames)),
    setCasinoGame: (cGame: CasinoGameDTO) => dispatch(setCasinoGame(cGame)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IndianCasinoView);
